import {createContext, useContext} from "react";
import API from "../services/api";

const api = new API();
(async () => {
  await api.checkAuthorization();
})();
export const Context = createContext(api);
export const useAPI = () => useContext(Context);
